import { render } from "./ThemeDevelopment.vue?vue&type=template&id=94856e28&ts=true"
import script from "./ThemeDevelopment.vue?vue&type=script&lang=ts"
export * from "./ThemeDevelopment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__